import styled from '@emotion/styled'
import { Box, TableCell, TableRow } from '@mui/material'

export const EditChartDataTableContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
`

export const TableContainer = styled(Box)`
  max-height: 380px;
  overflow-y: auto;
  position: relative;

  .MuiTable-root {
    position: relative;
  }

  .MuiTableHead-root {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
  }

  /* Add shadow effect to fixed header */
  .MuiTableHead-root::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: rgba(224, 224, 224, 1);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  }
`

export const ChartTableRow = styled(TableRow)`
  height: 60px;
`

export const ChartDateCell = styled(TableCell)`
  padding: 10px;
  white-space: nowrap;
`

export const ChartTableCell = styled(TableCell)`
  padding: 10px 20px 10px 10px;
`

export const CategoryHeaderCell = styled(ChartTableCell)`
  align-items: center;
  gap: 8px;
`

export const ColorDot = styled.span<{ color: string }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  margin-left: 10px;
  flex-shrink: 0;
`

export const RowActions = styled(Box)`
  display: flex;
  gap: 16px;
  justify-content: center;
`
